import { render, staticRenderFns } from "./popup-category.vue?vue&type=template&id=214aa027&scoped=true"
import script from "./popup-category.vue?vue&type=script&lang=js"
export * from "./popup-category.vue?vue&type=script&lang=js"
import style0 from "./popup-category.vue?vue&type=style&index=0&id=214aa027&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214aa027",
  null
  
)

export default component.exports